/**
 * @file Automatically generated by barrelsby.
 */

export * from './past-releases-table.component';
